import httpClient from '@/api/httpClient';

const save = (editConfigurationData, editToken) => {
    return httpClient.post(`change-configuration-data/${editToken}`, editConfigurationData);
};

export default {
    save,
};
